module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/Commission Plan Image-07a2b4043805c58b.png"+" 420w",
        images: [{path: __webpack_public_path__ + "assets/images/Commission Plan Image-07a2b4043805c58b.png",width: 420,height: 800}],
        src: __webpack_public_path__ + "assets/images/Commission Plan Image-07a2b4043805c58b.png",
        toString: function(){return __webpack_public_path__ + "assets/images/Commission Plan Image-07a2b4043805c58b.png"},
        
        width: 420,
        height: 800
      }